export default __webpack_public_path__ + "static/media/ic-operation.553b520d.svg";